import { HabitSchedule, Timestamp } from '@griply/types';

import { getActualScheduleStartDate } from './get-actual-schedule-start-date';
import { getScheduleEndDate } from './get-schedule-end-date';
import { isDegenerateSchedule } from './is-degenerate-schedule';
import { normalizeSchedules } from './normalize-schedules';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export const getTimeframeSchedules = (
  schedules: HabitSchedule[],
  { startDate, endDate }: Options,
) =>
  normalizeSchedules(schedules).filter(
    (schedule) =>
      !isDegenerateSchedule(schedule) &&
      getActualScheduleStartDate(schedule) <= endDate &&
      (!schedule.endDate || getScheduleEndDate(schedule)! >= startDate),
  );
